import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: true,
  isOpenedSideBar: false
};

export const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setIsOpen: (state, action) => {
      state.isOpen = action.payload;
    },
    setIsOpenedSideBar: (state, action) => {
      state.isOpenedSideBar = action.payload;
    }
  }
});

export const { setIsOpen, setIsOpenedSideBar } = headerSlice.actions;

export default headerSlice.reducer;
